import Decimal from "decimal.js";
import { DateOnly } from "@hantera/design-system";

/**
 * Coerces a wire value (Decimal, number, string) to a JS number for charting and arithmetic.
 */
export function toNumber(value: unknown): number {
  if (value == null) return 0;
  if (value instanceof Decimal) return value.toNumber();
  if (typeof value === "number") return value;
  if (typeof value === "string") return Number(value);
  return 0;
}

/**
 * Coerces a wire timestamp (Date, DateOnly, ISO string) to epoch milliseconds, or null if unparseable.
 */
export function toTime(value: unknown): number | null {
  if (value == null) return null;
  if (value instanceof Date) return value.getTime();
  if (value instanceof DateOnly) return value.toDate().getTime();
  if (typeof value === "string") {
    const time = new Date(value).getTime();
    return Number.isNaN(time) ? null : time;
  }
  return null;
}

/**
 * Shared series labels and colours for the inventory stock chart. The chart and
 * the overview legend both read from here so a legend dot always matches the
 * series it selects.
 */
export const INVENTORY_SERIES = {
  physical: { label: "Physical stock", color: "var(--chart-1)" },
  incoming: { label: "Incoming (projected)", color: "var(--chart-3)" },
  reservations: { label: "Reservations", color: "var(--warning)" },
  allocated: { label: "Allocated", color: "var(--chart-2)" },
  backOrders: { label: "Back orders", color: "var(--destructive)" },
} as const;
